import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { NoticeListItem } from '../components/NoticeListItem';
import { DownloadCard } from '../components/DownloadCard';
import { notices } from '../data/notices';
import { downloads } from '../data/downloads';
import { Bell, FileText } from 'lucide-react';
export function MembersInformation() {
  return <div className="w-full bg-club-canvas pb-24" data-id="element-1199">
      <PageBanner title="Information to Members" eyebrow="Notices & Resources" image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" data-id="element-1200" />

      <div className="max-w-7xl mx-auto px-4 mt-20" data-id="element-1201">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1202">
          {/* Notices Section */}
          <div data-id="element-1203">
            <div className="flex items-center gap-3 mb-8 border-b border-club-border pb-4" data-id="element-1204">
              <Bell className="text-club-gold" size={28} data-id="element-1205" />
              <h2 className="text-3xl" data-id="element-1206">Official Notices</h2>
            </div>
            <div className="space-y-6" data-id="element-1207">
              {notices.map(notice => <NoticeListItem key={notice.id} date={notice.date} title={notice.title} desc={notice.content} isNew={notice.isNew} data-id="element-1208" />)}
            </div>
          </div>

          {/* Downloads Section */}
          <div data-id="element-1209">
            <div className="flex items-center gap-3 mb-8 border-b border-club-border pb-4" data-id="element-1210">
              <FileText className="text-club-gold" size={28} data-id="element-1211" />
              <h2 className="text-3xl" data-id="element-1212">Downloads & Forms</h2>
            </div>
            <div className="grid grid-cols-1 gap-4" data-id="element-1213">
              {downloads.map(doc => <DownloadCard key={doc.id} title={doc.title} type={doc.type} size={doc.size} category={doc.category} data-id="element-1214" />)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}